module.exports = __webpack_public_path__ + "static/media/icon_come_back.3587cc46.svg";